import { FormDefinition } from '../components/SchemaForm/SchemaForm.model'

export const formDefinition: FormDefinition = {
  formTitle: 'สั่งซื้อ Customize Wallpaper',
  formDescription: 'เพื่อการสั่งซื้อที่ครบถ้วนสมบูรณ์ กรุณาให้ข้อมูลเพิ่มเติม',
  summaryTitle: 'ยืนยันคำสั่งซื้อ Customize Wallpaper',
  numberOfPage: 2,
  paymentMethod: 'PAY_SOLUTION',
  defaultValues: {
    collection: 'celestial_eden',
    allowNewsletter: 'false',
    saleChannel: 'online',
  },
  pageCardIndexOption: {
    1: {
      0: {
        cardTitle: 'ข้อมูลส่วนตัว',
      },
    },
  },
  summaryCardIndexOption: {
    1: {
      cardTitle: 'ข้อมูลคอลเลคชันวอลเปเปอร์',
    },
    2: {
      cardTitle: 'ข้อมูลส่วนตัว',
      backPageOption: {
        label: 'แก้ไขข้อมูล',
        toPageIndex: 1,
      },
    },
  },
  fields: [
    {
      type: 'readonlyInput',
      name: 'collection',
      pageIndex: 0,
      cardIndex: 0,
      title: 'คอลเลคชันวอลเปเปอร์ที่คุณลูกค้าสั่งซื้อ',
      properties: {
        readonlyInputValue: 'Celestial Eden Collection',
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'template',
      pageIndex: 0,
      cardIndex: 1,
      title: 'แบบวอลเปเปอร์ที่คุณต้องการ',
      description: '(เลือก 1 แบบเท่านั้น)',
      properties: {
        controlOptions: [
          {
            label: 'Solar Ascend การงาน / ความสำเร็จ',
            value: 'solar_ascend',
            modalData: {
              title: 'Solar Ascend การงาน / ความสำเร็จ',
              content: `<p><b>Wallpaper for Career Success & Recognition</b></p>
              <p>วอลเปเปอร์แห่งความสำเร็จ ชื่อเสียง การเติบโตในหน้าที่การงาน วอลเปเปอร์นี้ถูกออกแบบภายใต้พลังของ ดาวอาทิตย์ ดาวแห่งชื่อเสียง ความสำเร็จ ภาวะผู้นำ และการเป็นที่ยอมรับในสังคม โดยผสานกับพลังแห่งธรรมชาติที่สะท้อนการเติบโตและการก้าวขึ้นสู่จุดสูงสุดของชีวิตการงาน</p>
              <p><b>สัญลักษณ์ทางดวง (Elements):</b></br>
              ☀️ พระอาทิตย์ขึ้น - สัญลักษณ์ของการเริ่มต้นใหม่ การได้รับโอกาสครั้งสำคัญ และช่วงเวลาที่ชีวิตกำลังเปล่งประกาย</br>
              ⛰️ ภูเขา - สื่อถึงความมั่นคง ความอดทน และเป้าหมายที่ยิ่งใหญ่</br>
              🌿 ช่อมะกอก - สัญลักษณ์ของชัยชนะ เกียรติยศ และการได้รับการยอมรับ</br>
              🌺 ดอกพีโอนี - ดอกไม้แห่งความหรูหรา ความมั่งคั่ง และชื่อเสียง</br>
              💧 น้ำตก - สื่อถึงการปลดปล่อยอุปสรรคและทำให้เส้นทางการงานราบรื่น</br>
              🪞 กระจก - สัญลักษณ์ของการสะท้อนตัวตนที่แท้จริง ช่วยดึงพลังแห่งความมั่นใจ</br>
              🏛️ ประตูชัย - หมายถึงการก้าวผ่านอุปสรรคและเข้าสู่ช่วงเวลาแห่งชัยชนะ</br>
              🦅 นกอินทรี - ตัวแทนของวิสัยทัศน์ที่กว้างไกล การมองเห็นโอกาสก่อนใคร</br>
              </p>
              <p><b>Sacred Color Energy:</b></br>
              🔴 สีแดงเข้ม - ได้รับแรงบันดาลใจจากพลังของดาวอาทิตย์ สัญลักษณ์ของชื่อเสียง อำนาจ ความมั่นใจ ภาวะผู้นำ</br>
              🟠 สีส้มทอง - เป็นพลังของดาวพฤหัสบดี ดาวแห่งการขยายตัว ความสำเร็จ</br>
              ✨ เมื่อสีของดาวอาทิตย์และดาวพฤหัสรวมกัน จึงกลายเป็นพลังของ "ความสำเร็จที่ยิ่งใหญ่และยั่งยืน"
              </p>
              <p><b>เหมาะกับใคร:</b></br>
              - วอลเปเปอร์นี้เหมาะกับคนที่กำลังอยู่ในช่วงชีวิตที่ต้องการ "เติบโตแบบก้าวกระโดด"</br>
              - คนที่อยากเลื่อนตำแหน่ง</br>
              - คนที่อยากมีชื่อเสียง เป็นที่ยอมรับในสายงาน</br>
              - เจ้าของธุรกิจที่อยากขยายกิจการ</br>
              - คนที่อยากเสริมภาวะผู้นำ ความมั่นใจ และ authority</br>
              </p>`,
            },
          },
          {
            label: 'Venus Vault การเงิน / ความมั่งคั่ง',
            value: 'venus_vault',
            modalData: {
              title: 'Venus Vault การเงิน / ความมั่งคั่ง',
              content: `<p><b>Wallpaper for Wealth & Abundance</b></p>
              <p>วอลเปเปอร์แห่งเงินทอง ความมั่งคั่ง และการรักษาเงินให้อยู่กับตัว วอลเปเปอร์นี้ได้รับแรงบันดาลใจจาก ดาวศุกร์ ดาวแห่งความมั่งคั่ง ความสุขสบาย โชคลาภและทรัพย์สินที่งอกเงย</p>
              <p><b>สัญลักษณ์ทางดวง (Elements):</b></br>
              🌊 น้ำวน - ไม่ได้หมายถึงการสูญเสีย แต่เป็นพลังของเงินที่หมุนเวียนกลับเข้าสู่ชีวิตอย่างต่อเนื่อง</br>
              🐚 เปลือกหอยและไข่มุก - ไข่มุกเกิดจากเวลาและการบ่มเพาะ เปรียบเสมือนทรัพย์สินที่เติบโตอย่างมีคุณค่า</br>
              🪙 เหรียญที่ตกลงในน้ำ - สื่อถึงโชคลาภที่เข้ามาแบบไม่คาดคิด</br>
              💎 สมบัติและอัญมณี - เป็นตัวแทนของ abundance หรือความอุดมสมบูรณ์ขั้นสูงสุด</br>
              </p>
              <p><b>Sacred Color Energy:</b></br>
              🔵 สีฟ้ามุก / ฟ้าเงิน - ได้รับแรงบันดาลใจจากดาวศุกร์ สัญลักษณ์ของทรัพย์สิน ความหรูหรา ความสุขสบาย ความมั่งคั่ง</br>
              🤍 สีขาวมุก - เสริมพลังของความบริสุทธิ์ ความชัดเจนทางการเงิน และการเก็บรักษาทรัพย์</br>
              </p>
              <p><b>เหมาะกับใคร:</b></br>
              - วอลเปเปอร์นี้เหมาะกับคนที่ต้องการเรียกพลังแห่งความมั่งคั่งและเก็บเงินให้อยู่</br>
              - คนที่อยากเพิ่มรายได้</br>
              - คนที่เงินเข้าเยอะแต่เก็บไม่อยู่</br>
              - คนที่ต้องการดึงดูดโชคลาภด้านการเงิน</br>
              - คนทำธุรกิจ ค้าขาย ลงทุน</br>
              - คนที่อยากสร้างความมั่นคงทางการเงินระยะยาว</br>
              </p>`,
            },
          },
          {
            label: 'Bloom of Venus ความรัก / เสน่ห์เมตตา',
            value: 'bloom_of_venus',
            modalData: {
              title: 'Bloom of Venus ความรัก / เสน่ห์เมตตา',
              content: `<p><b>Wallpaper for Love & Attraction</b></p>
              <p>วอลเปเปอร์แห่งความรัก เสน่ห์ และความสัมพันธ์ที่มั่นคง วอลเปเปอร์แห่งความรักนี้ผสานพลังของ ดาวศุกร์ และ ดาวอังคาร เพื่อสร้างสมดุลระหว่างความอ่อนโยนและแรงดึงดูด</p>
              <p><b>สัญลักษณ์ทางดวง (Elements):</b></br>
              🌸 สวนดอกไม้ - สื่อถึงความรักที่เติบโตอย่างสวยงามตามธรรมชาติ</br>
              🍎 ผลทับทิม - เป็นสัญลักษณ์ของความรัก ความอุดมสมบูรณ์ และครอบครัว</br>
              🦢 หงส์คู่ - ตัวแทนของ soulmate และความสัมพันธ์ที่มั่นคง</br>
              🏛️ ศาลาทรงโรมัน - สื่อถึงพื้นที่ปลอดภัยของหัวใจ และความมั่นคงในความสัมพันธ์</br>
              💧 น้ำตกและแอ่งน้ำ - แทนพลังแห่งอารมณ์ ความสดใหม่ และการไหลเวียนของความรู้สึกดี</br>
              🏆 ถ้วยน้ำล้น - เป็นสัญลักษณ์ของความรักที่เต็มเปี่ยม การถูกรัก และ emotional fulfillment</br>
              </p>
              <p><b>Sacred Color Energy:</b></br>
              💗 สีชมพูอ่อน - เป็นสีหลักของดาวศุกร์ ดาวแห่งความรัก ความสัมพันธ์ ความอ่อนโยน และเสน่ห์</br>
              🔵 สีฟ้าอ่อน - ได้รับแรงบันดาลใจจากดาวอังคาร พลังแห่ง passion ความกล้า และแรงดึงดูดทางเสน่ห์</br>
              </p>
              <p><b>เหมาะกับใคร:</b></br>
              - วอลเปเปอร์นี้เหมาะกับคนที่ต้องการเปิดพลังหัวใจและเสน่ห์ในชีวิตรัก</br>
              - คนโสดที่อยากเจอความรักดี ๆ</br>
              - คนที่ต้องการความเมตตาจากรอบข้าง</br>
              - คนที่อยากเพิ่มเสน่ห์ ดึงดูดคนเข้ามา</br>
              - คนที่อยากเจอ soulmate</br>
              - คนที่ต้องการฟื้นฟูความสัมพันธ์</br>
              - คนมีคู่ที่อยากเติมความหวาน</br>
              - คนที่อยากเยียวยาหัวใจจากความรักเก่า</br>
              </p>`,
            },
          },
          {
            label: 'Infinite Fortune โชคลาภ / โอกาส',
            value: 'infinite_fortune',
            modalData: {
              title: 'Infinite Fortune โชคลาภ / โอกาส',
              content: `<p><b>Wallpaper for Luck & Opportunity</b></p>
              <p>วอลเปเปอร์แห่งโชคลาภ โอกาส และการเปิดทางชีวิต วอลเปเปอร์นี้ได้รับแรงบันดาลใจจากพลังของ ดาวศุกร์ + ดาวพฤหัสบดี ซึ่งเป็นดาวแห่งโชคลาภและการขยายตัว</p>
              <p><b>สัญลักษณ์ทางดวง (Elements):</b></br>
              ☁️ ท้องฟ้าและเมฆ - แทนความเป็นไปได้แบบไร้ขีดจำกัด</br>
              ♾️ สัญลักษณ์ Infinity - สื่อถึงโชคลาภที่ไหลเข้ามาอย่างไม่มีที่สิ้นสุด</br>
              🌙 ดวงจันทร์ - ตัวแทนของโชคจากสิ่งที่มองไม่เห็น และโอกาสแบบไม่คาดฝัน</br>
              🚪 ประตูที่เปิดออก - หมายถึงโอกาสใหม่ที่กำลังรอคุณอยู่</br>
              🪜 บันได - แทนการยกระดับชีวิตทีละขั้น</br>
              ⚔️🪄🏆🪙 ธาตุทั้งสี่จากไพ่ทาโรต์ - เพื่อเสริมความสมดุลของชีวิตทั้งด้านงาน เงิน ความรัก และพลังแห่งชัยชนะ</br>
              </p>
              <p><b>Sacred Color Energy:</b></br>
              🔵 สีฟ้าแห่งท้องฟ้า - ได้รับแรงบันดาลใจจากดาวศุกร์ ช่วยเปิดพลังของโชคลาภ ความสบายใจ และความมั่งคั่ง</br>
              🟠 สีส้มทอง - เป็นพลังของดาวพฤหัสบดี ดาวแห่งโชคใหญ่ การขยายตัว และโอกาสแบบก้าวกระโดด</br>
              </p>
              <p><b>เหมาะกับใคร:</b></br>
              - วอลเปเปอร์นี้เหมาะกับคนที่ต้องการเปิดดวงและเรียกโอกาสใหม่เข้ามาในชีวิต</br>
              - คนที่รู้สึกชีวิตนิ่ง ๆ ตัน ๆ</br>
              - คนที่อยากได้โชคลาภ</br>
              - คนที่กำลังรอโอกาสใหม่</br>
              - คนที่อยากเปิดดวงก่อนเริ่มโปรเจกต์สำคัญ</br>
              - คนที่ต้องการแรงสนับสนุนจากจักรวาล</br>
              - คนที่อยากให้ชีวิตมีจังหวะดี ๆ เข้ามามากขึ้น</br>
              </p>`,
            },
          },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'choice',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่อยากเน้นเป็นพิเศษ',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      properties: {
        controlOptions: [
          { label: 'การเงิน', value: 'money' },
          { label: 'ความรัก/เสน่ห์ เมตตา', value: 'love' },
          { label: 'การงาน/ความสำเร็จ', value: 'work' },
          { label: 'โชคลาภ', value: 'luck' },
          { label: 'การเรียน/สอบแข่งขัน', value: 'study' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice1',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['love'] },
      properties: {
        controlOptions: [
          { label: 'คนโสด', value: 'single' },
          { label: 'คนมีคู่', value: 'in_relationship' },
          { label: 'คนคุย', value: 'complicated' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice2',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['love'], subChoice1: ['single'] },
      properties: {
        controlOptions: [
          { label: 'เพิ่มเสน่ห์ให้คนสนใจ', value: 'charming' },
          { label: 'ดึงดูดชาวต่างชาติ', value: 'foreigner' },
          { label: 'ตามหารักแท้', value: 'true_love' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice2',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['love'], subChoice1: ['in_relationship'] },
      properties: {
        controlOptions: [
          { label: 'แฟนคลั่งรัก', value: 'f_addiction' },
          { label: 'แฟนเปย์ จ่ายเงินให้', value: 'money_supporter' },
          { label: 'ส่งเสริมซึ่งกันและกัน', value: 'real_supporter' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice2',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['love'], subChoice1: ['complicated'] },
      properties: {
        controlOptions: [
          { label: 'ได้คุยกันมากขึ้น', value: 'talk_more' },
          { label: 'ความสัมพันธ์พัฒนามากขึ้น', value: 'step_forward' },
          { label: 'อีกฝ่ายคลั่งรัก', value: 'addiction' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice1',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['work'] },
      properties: {
        controlOptions: [
          { label: 'หางาน', value: 'seeking' },
          { label: 'มีงาน', value: 'working' },
          { label: 'ฟรีแลนซ์', value: 'freelancing' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice2',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['work'], subChoice1: ['seeking'] },
      properties: {
        controlOptions: [
          { label: 'ได้งานใหม่ที่ถูกใจ', value: 'good_job' },
          { label: 'งานอะไรก็ได้ที่เข้ามาไวๆ', value: 'quick_job' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice2',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['work'], subChoice1: ['working'] },
      properties: {
        controlOptions: [
          { label: 'งานราบรื่น ไม่มีอุปสรรค', value: 'smooth' },
          { label: 'งานประสบความสำเร็จ', value: 'success' },
          { label: 'เจ้านายเอ็นดู คนช่วยเหลืออุปถัมภ์', value: 'manager_support' },
          { label: 'สามารถปิดดีล เจรจาได้ลงตัว', value: 'close_deal' },
          { label: 'ได้เลื่อนขั้น เลื่อนตำแหน่ง', value: 'promotion' },
          { label: 'มีเสน่ห์ คนอยากติดตาม', value: 'charisma' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice2',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['work'], subChoice1: ['freelancing'] },
      properties: {
        controlOptions: [
          { label: 'มีงานเข้ามาเยอะๆ', value: 'more_work' },
          { label: 'ฝีมือดีขึ้น ไอเดียบรรเจิด', value: 'more_idea' },
          { label: 'ปิดดีล เจรจาลงตัว', value: 'fl_close_deal' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice1',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['money'] },
      properties: {
        controlOptions: [
          { label: 'มีเงินเข้ามาไม่ขาดมือ ', value: 'continuous' },
          { label: 'มีช่องทางการหาเงินใหม่ๆ', value: 'new_channel' },
          { label: 'มีคนมาอุปถัมภ์เรื่องการเงิน', value: 'fi_supporter' },
          { label: 'เก็บเงินอยู่', value: 'saving' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice1',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['luck'] },
      properties: {
        controlOptions: [
          { label: 'มีโชคเรื่องการเงิน ', value: 'fortune' },
          { label: 'การเสี่ยงโชค', value: 'gamble' },
          { label: 'สุ่มของที่ต้องใช้โชค', value: 'gacha' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice1',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['study'] },
      properties: {
        controlOptions: [
          { label: 'ได้คะแนนดี', value: 'good_score' },
          { label: 'มีสมาธิ ตั้งใจเรียน', value: 'concentration' },
          { label: 'สอบชิงทุน สอบเพื่อไปต่างประเทศ', value: 'inter_exam' },
          { label: 'สอบเข้ามหาลัยในประเทศ', value: 'dom_exam' },
          { label: 'ทำโปรเจกต์จบ', value: 'final_project' },
          { label: 'อาจารย์เอ็นดู คอยช่วยเหลือ', value: 'prof_supporter' },
        ],
      },
    },
    {
      type: 'radio',
      name: 'customCircle',
      pageIndex: 0,
      cardIndex: 2,
      title: 'บริการเสริม',
      hideTitleRequired: true,
      showSubtitleRequired: true,
      required: true,
      subtitle:
        'ใส่รูปพื้นหลังดวงจักรราศีของตัวเอง เพื่อช่วยให้วอลเปเปอร์เสริมพลังตัวเรามากขึ้น (เพิ่ม 50 บาท)',
      properties: {
        controlOptions: [
          { label: 'รับ', value: 'true' },
          { label: 'ไม่รับ', value: 'false' },
        ],
      },
    },
    {
      type: 'radio',
      name: 'startTimeUse',
      required: true,
      pageIndex: 0,
      cardIndex: 2,
      hideTitleRequired: true,
      showSubtitleRequired: true,
      subtitle:
        'บริการหาฤกษ์มงคลในการเริ่มใช้วอลเปเปอร์ (เพิ่ม 50 บาท) หากลูกค้าต้องการฤกษ์ใหม่ เนื่องจากใช้ตามฤกษ์ที่ให้ไว้ไม่ทันจะมีค่าบริการเพิ่มอีก 50 บาท',
      properties: {
        controlOptions: [
          { label: 'รับ', value: 'true' },
          { label: 'ไม่รับ', value: 'false' },
        ],
      },
    },
    {
      type: 'textInput',
      name: 'customerFirstname',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      label: 'ชื่อ',
      properties: {
        placeholder: 'กรุณากรอกชื่อ',
      },
    },
    {
      type: 'textInput',
      name: 'customerLastname',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      label: 'นามสกุล',
      properties: {
        placeholder: 'กรุณากรอกนามสกุล',
      },
    },
    {
      type: 'date',
      name: 'dateOfBirth',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      label: 'วันเกิด',
    },
    {
      type: 'time',
      name: 'timeOfBirth',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      label: 'เวลาเกิด',
      properties: {
        hasDisableTime: true,
        disableTimeCheckboxLabel: 'ไม่ทราบเวลาเกิด',
        defaultValueIfEmpty: '06:00',
      },
    },
    {
      type: 'select',
      required: true,
      name: 'gender',
      pageIndex: 1,
      cardIndex: 0,
      label: 'เพศ',
      properties: {
        controlOptions: [
          { label: 'ชาย', value: 'M' },
          { label: 'หญิง', value: 'F' },
          { label: 'LGBTQ+แนวหวาน', value: 'LGBTQ_F' },
          { label: 'LGBTQ+แนวแมน', value: 'LGBTQ_M' },
        ],
        placeholder: 'กรุณาเลือกเพศ',
      },
    },
    {
      type: 'textInput',
      name: 'genderText',
      pageIndex: 1,
      cardIndex: 0,
      dependsOn: { gender: ['LGBTQ_F', 'LGBTQ_M'] },
      properties: {
        numberOfLines: 2,
        placeholder: 'อธิบายเพิ่มเติม... (เช่น ฉันเป็นผู้ชายที่ชอบมองผู้ชาย ด้วยกัน)',
      },
    },
    {
      type: 'select',
      name: 'disease',
      label: 'คุณมีโรคประจำตัวตามนี้หรือไม่',
      footerText: '(บางโรคจะมีผลกับการที่แม่หมอจัดไพ่ จะได้ปรับหน้าไพ่ได้ดีขึ้น)',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      properties: {
        controlOptions: [
          { label: 'ไม่มี', value: 'healthy' },
          { label: 'ต่อมน้ำเหลือง ฮอร์โมน อ้วน', value: 'hormone' },
          { label: 'โรคกระเพาะ', value: 'digest' },
          { label: 'มะเร็ง ก้อนเนื้อ', value: 'cancer' },
          { label: 'ไมเกรน ปวดหัวบ่อย', value: 'migrane' },
          { label: 'ซีมเศร้า ไบโพลาร์', value: 'mental' },
        ],
        placeholder: 'กรุณาเลือกโรคประจำตัว',
      },
    },
    {
      type: 'tel',
      name: 'telephone',
      label: 'เบอร์โทรศัพท์',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      properties: {
        placeholder: 'กรุณากรอกเบอร์โทรศัพท์',
        textMaxLength: 12,
      },
    },
    {
      type: 'email',
      name: 'email',
      label: 'อีเมล์',
      footerText:
        '*ควรใส่เบอร์โทรศัพท์และอีเมล์ที่ใช้ประจำและสามารถติดต่อได้ เพื่อแจ้งเตือนการยืนยันการสั่งซื้อและการรับ Wallpaper',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      properties: {
        placeholder: 'กรุณากรอกอีเมล์',
      },
    },
    {
      type: 'textInput',
      name: 'remark',
      title: 'หมายเหตุ (ถ้ามี)',
      titleFontWeight: '400',
      description:
        'คอลเล็กชั่นนี้คุณลูกค้าจะไม่สามารถเลือกสีเองได้ แม่หมอจะช่วยเลือกสีให้ตามดวง โดยการคำนวณดวงจากศาสตร์ที่ละเอียดที่สุด เพื่อให้วอลเปเปอร์นั้นส่งผลกับลูกค้าได้ตรงกับดวงเฉพาะบุคคลที่สุด แต่สิ่งที่คุณลูกค้าจะเลือกได้คือ พื้นหลังวอลเปเปอร์ว่าอยากได้เรื่องอะไร และไพ่ว่าอยากให้ส่งผลเรื่องอะไร เพื่อให้ตรงกับเรื่องที่อยากได้ที่สุด',
      pageIndex: 1,
      cardIndex: 0,
      properties: {
        placeholder: 'โปรดระบุ...',
        numberOfLines: 5,
        textMaxLength: 150,
      },
    },
    {
      type: 'checkbox',
      label: 'รับข้อมูลข่าวสาร',
      hideFormLabel: true,
      name: 'allowNewsletter',
      pageIndex: 1,
      cardIndex: 1,
      properties: {
        checkboxLabel:
          'ฉันยินดีรับข้อมูลข่าวสาร (Newsletter) กิจกรรม รวมถึงข้อความทางการตลาดต่างๆของมูเตเวิร์ล ผ่านระบบ E-mail หรือผ่านแพลตฟอร์มต่างๆ ของมูเตเวิร์ล',
      },
    },
    {
      type: 'policyCheckbox',
      name: 'acceptTerms',
      pageIndex: 1,
      cardIndex: 1,
      properties: {
        policyModalData: {
          title: 'ข้อตกลงและเงื่อนไข',
          content: `
          <h2><strong>Term Of Service</strong><br /><strong>ข้อตกลงและเงื่อนไขการใช้บริการ</strong><br /><strong>"มูเตเวิร์ล Mootae World"</strong></h2>
<p><em>ครอบคลุมถึง ช่องทางการสื่อสาร เว็บไซต์ และแพลตฟอร์มอื่นๆ ของมูเตเวิร์ล ที่มีอยู่และจะเกิดขึ้นในอนาคต</em></p>
<p><br />เพื่อปกป้องสิทธิของทุกฝ่ายที่เกี่ยวข้อง ข้อตกลงและเงื่อนไขการใช้บริการนี้จะกำกับดูแลการใช้บริการกับมูเตเวิร์ล ทั้งบนเว็บไซต์ (Website) และแอพพลิเคชั่น (Application) ทั้งบนระบบปฏิบัติการไอโอเอส ("iOS") และบนระบบปฏิบัติการแอนดรอยด์ ("Android") ตลอดจนช่องทางการติดต่อสื่อสารต่าง ๆ บนแพลตฟอร์ม Social Network ต่างๆ อาทิ Facebook Page, Instagram และ Line เป็นต้น ทั้งนี้ จะประกอบด้วยข้อตกลงและเงื่อนไขด้านล่าง พร้อมกับเงื่อนไขที่กำหนดไว้ในนโยบายความเป็นส่วนตัว</p>`,
        },
      },
    },
  ],
  summaryFields: [
    {
      type: 'readonlyInput',
      name: 'collection',
      label: 'คอลเลคชันวอลเปเปอร์ที่คุณลูกค้าสั่งซื้อ',
      labelFontWeight: '700',
      properties: {
        readonlyInputValue: 'Celestial Eden Collection',
      },
      cardIndex: 0,
    },
    {
      name: 'template',
      cardIndex: 1,
    },
    {
      name: 'choice',
      label: 'เรื่องที่ต้องการเสริม',
      cardIndex: 1,
    },
    {
      name: 'subChoice1',
      label: 'สิ่งที่ต้องการเสริม',
      cardIndex: 1,
    },
    {
      name: 'subChoice2',
      label: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      cardIndex: 1,
    },
    {
      name: 'customCircle',
      label: 'ใส่รูปพื้นหลังดวงจักรราศีของตัวเอง (เพิ่ม 50 บาท)',
      cardIndex: 1,
    },
    {
      name: 'startTimeUse',
      label: 'บริการหาฤกษ์มงคลในการเริ่มใช้วอลเปเปอร์ (เพิ่ม 50 บาท)',
      cardIndex: 1,
    },
    {
      names: ['customerFirstname', 'customerLastname'],
      label: 'ชื่อ - นามสกุล',
      cardIndex: 2,
    },
    {
      type: 'date',
      name: 'dateOfBirth',
      label: 'วัน/เดือน/ปี เกิด',
      cardIndex: 2,
    },
    {
      name: 'timeOfBirth',
      cardIndex: 2,
    },
    {
      name: 'gender',
      cardIndex: 2,
    },
    {
      name: 'genderText',
      cardIndex: 2,
    },
    {
      name: 'disease',
      label: 'โรคประจำตัว',
      cardIndex: 2,
    },
    {
      name: 'telephone',
      cardIndex: 2,
    },
    {
      name: 'email',
      cardIndex: 2,
    },
    {
      name: 'remark',
      cardIndex: 2,
      label: 'หมายเหตุ',
    },
    {
      name: 'divider-1',
      type: 'divider',
      cardIndex: 2,
    },
    {
      name: 'allowNewsletter',
      cardIndex: 2,
      textObject: {
        true: 'ฉันยินดีรับข้อมูลข่าวสาร (Newsletter)',
        false: 'ฉันไม่รับข้อมูลข่าวสาร (Newsletter)',
      },
    },
    {
      template: 'discountCode',
      cardIndex: 3,
    },
  ],
}
